export default "__VITE_ASSET__Cerjsvv9__"